import apiService from '../../services/api';

// Init state
const state = {
    items: []
};

// Actions
const actions = {
    getList: (context, params) => {
        return apiService.get('point.index', params);
    },
    create: (context, params) => {
        return apiService.post('point.index', params);
    },
    update: (context, params) => {
        return apiService.put('point.detail', params);
    },
    delete: (context, params) => {
        return apiService.delete('point.detail', params);
    }
};

// Mutation
const mutations = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
